var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessCheckmarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0833 0C18.8533 0 0 18.8533 0 42.0833C0 65.3133 18.8533 84.1667 42.0833 84.1667C65.3133 84.1667 84.1667 65.3133 84.1667 42.0833C84.1667 18.8533 65.3133 0 42.0833 0ZM42.0833 75.75C23.5246 75.75 8.41667 60.6421 8.41667 42.0833C8.41667 23.5246 23.5246 8.41667 42.0833 8.41667C60.6421 8.41667 75.75 23.5246 75.75 42.0833C75.75 60.6421 60.6421 75.75 42.0833 75.75ZM61.3996 23.4825L33.6667 51.2154L22.7671 40.3579L16.8333 46.2917L33.6667 63.125L67.3333 29.4583L61.3996 23.4825Z",
    fill: "#41C789"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckmarkIcon);
export default __webpack_public_path__ + "static/media/success-checkmark-icon.69c0e598.svg";
export { ForwardRef as ReactComponent };